export class GcpVmSnapshotProperties {
    'name';
    'region';
    'machineType';
    'network';
    'metadata';
    'disks';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "machineType",
            "baseName": "machineType",
            "type": "string",
            "format": ""
        },
        {
            "name": "network",
            "baseName": "network",
            "type": "string",
            "format": ""
        },
        {
            "name": "metadata",
            "baseName": "metadata",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "disks",
            "baseName": "disks",
            "type": "Array<GcpDiskSnapshotProperties>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpVmSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
